import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const SearchTakeMoney = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            P_note,
            AddProChange,
            P_calculateBripara,
            P_qarzeKonDolar,
            P_qarzeKonID,
            P_joripara,
            P_briparaypechawana,
            bripara,
            P_getIsChecked,
            P_isChecked,
            P_del_dis,
            Money_peshandaniQarzyPeshw_kon,
            dinartodolar,
            dolartodinar,
            W_wakelakan,
            P_nawe_barez,
            P_qarzeKonDolar_,
            P_qarzeKonID_
          } = value;
          const wakilakn = W_wakelakan.filter((user) => {
            return user.Name.trim().startsWith(P_nawe_barez);
          }).map((item, index) => {
            return (
              <option className="fk" key={index}>
                {item.Name}
              </option>
            );
          });
          return (
            <>
              <div
                className="card card-primary text-warning font-weight-bold"
                style={{ backgroundColor: "#2C3539" }}
              >
                <div
                  className="card-header border-bottom border-warning"
                  style={{ backgroundColor: "#2C3539" }}
                >
                  <h3 className="card-title tc "> گەران بە دوای </h3>
                </div>

                <form>
                  <div className="card-body text-right">
                    {P_joripara == "دۆلار" ? (
                      <div className="form-group">
                        <label className="font-weight-bold f4">
                          دۆلار بۆ دینار
                        </label>
                        <NumberFormat
                          value={dolartodinar(P_qarzeKonDolar)}
                          thousandSeparator={true}
                          className="form-control text-right font-weight-bold"
                          displayType="text"
                          disabled={P_del_dis ? true : null}
                        />
                      </div>
                    ) : (
                      <div className="form-group">
                        <label className="font-weight-bold f4">
                          دینار بۆ دۆلار{" "}
                        </label>
                        <NumberFormat
                            value={dinartodolar(P_qarzeKonID)}
                          thousandSeparator={true}
                          className="form-control text-right font-weight-bold"
                            disabled={P_del_dis ? true : null}
                          displayType="text"
                        />
                      </div>
                    )}

                    <div className="form-group">
                      <label className="font-weight-bold f4">
                        {P_joripara == "دۆلار" ? "ID" : "$"} بڕی پارەی پێچەوانە
                      </label>
                      <NumberFormat
                        onChange={P_calculateBripara}
                        value={P_briparaypechawana}
                        name="P_briparaypechawana"
                        thousandSeparator={true}
                        className="form-control text-right font-weight-bold"
                        disabled={P_del_dis ? true : null}
                        displayType="input"
                      />
                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold f4">
                        {P_joripara == "دۆلار" ? "ID" : "$"} قەرزی ماوە{" "}
                      </label>
                      {P_joripara == "دۆلار" ? (
                        <NumberFormat
                          value={dolartodinar(bripara())}
                          thousandSeparator={true}
                          className="form-control text-right font-weight-bold"
                          disabled={P_del_dis ? true : null}
                          displayType="text"
                        />
                      ) : (
                        <NumberFormat
                          value={dinartodolar(bripara())}
                          thousandSeparator={true}
                          className="form-control text-right font-weight-bold"
                          displayType="text"
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold f4">:تێبینی </label>
                      <input
                        type="text"
                        onChange={AddProChange}
                        value={P_note}
                        name="P_note"
                        className="form-control text-right font-weight-bold"
                        disabled={P_del_dis ? true : null}
                        placeholder="...تێبینی"
                      />
                    </div>
                  </div>
                  <div className="col-12 text-right ml5">
                    <table id="non">
                      <thead>
                        <tr>
                          <th className="text-right pb-2 text-warning f4">
                            <input
                              onChange={P_getIsChecked}
                              checked={P_isChecked == true ? true : false}
                              value={P_isChecked}
                              type="checkbox"
                              className="mr3"
                            />
                            :پیشاندانی قەرزی پێشوو
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {P_isChecked == true ? (
                          <>
                            <tr>
                              <td className="text-right">
                                <label className="font-weight-bold text-warning f4">
                                  : قەرزی کۆن
                                </label>
                                <NumberFormat
                                  value={
                                    P_joripara == "دۆلار"
                                      ? Number(P_qarzeKonDolar).toFixed(2)
                                      : Number(P_qarzeKonID).toFixed(2)
                                  }
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    P_joripara == null
                                      ? ""
                                      : P_joripara == "دۆلار"
                                      ? "$"
                                      : "ID"
                                  }
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="text-right ">
                                <label className="font-weight-bold text-warning f4">
                                  :قەرزی ئێستا
                                </label>
                                <NumberFormat
                                  value={Money_peshandaniQarzyPeshw_kon(P_joripara)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold"
                                  thousandSeparator={true}
                                  prefix={
                                    P_joripara == null
                                      ? ""
                                      : P_joripara == "دۆلار"
                                      ? "$"
                                      : "ID"
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    </table>
                  </div>

                  <div
                    className="card-footer"
                    style={{ backgroundColor: "#2C3539" }}
                  ></div>
                </form>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default SearchTakeMoney;
